import { Navigate, useLocation } from 'react-router-dom'

import { REDIRECT_PARAM } from '_constants/kb-links.constants'
import useAuthStore from '_stores/auth.store'

const CatchAllRoute = () => {
  const location = useLocation()
  const { user } = useAuthStore()

  if (user) {
    return <Navigate to="/" replace />
  }

  const target = `${location.pathname}${location.search || ''}`

  // Carry the intended URL through the login bounce. state.from only survives an in-app
  // redirect; an emailed deep link opened cold has no router state, so it must ride the query.
  return <Navigate to={`/login?${REDIRECT_PARAM}=${encodeURIComponent(target)}`} replace />
}

export default CatchAllRoute
